import React, { FC } from 'react';
import CalculatorResultList from 'evcharging/containers/ev-calculator/CalculatorResultList';
import CalculatorNetProfit from 'evcharging/containers/ev-calculator/CalculatorNetProfit';
import CalculatorSendResult from 'evcharging/containers/ev-calculator/CalculatorSendResult';
import useI18n from 'evcharging/hooks/useI18n';

export interface CalculatorResultsProps {
  fee: number;
  paymentFee: number;
  chargingPorts: number;
  estimatedCost: number;
  totalMonthlyCost: number;
  monthlyRevenue: number;
  netProfit: number;
  electricRate: number;
  chargePerKwh: number;
  chargePerHour: number;
  hoursPerDay: number;
  daysPerMonth: number;
  sellType: string;
}

export const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const CalculatorResults: FC<CalculatorResultsProps> = (props) => {
  const { fee, paymentFee, chargingPorts, estimatedCost, monthlyRevenue, netProfit } = props;
  const { t } = useI18n();

  return (
    <div>
      <CalculatorResultList
        items={[
          {
            label: t('calculator.result.revenue'),
            value: `${formatter.format(monthlyRevenue)}`,
          },
        ]}
      />
      <CalculatorResultList
        items={[
          {
            label: t('calculator.result.cost'),
            value: `-${formatter.format(estimatedCost)}`,
          },
          {
            label: `${t('calculator.result.fee')} ($30/${t('calculator.result.port')})`,
            value: `-${formatter.format(fee * chargingPorts)}`,
          },
          {
            label: `${t('calculator.result.payment-fee')} (5%)`,
            value: `-${formatter.format(paymentFee)}`,
          },
          /*{
            label: t('calculator.result.total'),
            value: `${formatter.format(totalMonthlyCost)}`,
          },*/
        ]}
      />
      <CalculatorNetProfit
        label={t('calculator.result.profit')}
        value={formatter.format(netProfit)}
      />
      <CalculatorSendResult {...props} />
    </div>
  );
};

export default CalculatorResults;
